export default "__VITE_ASSET__c3d99a27__"